import {englishMessages} from 'ra-language-english';
import frenchMessages from 'ra-language-french';

import customFrenchMessages from './fr_FR';
import customEnglishMessages from './en_US';

export default {
    fr_FR: {...frenchMessages, ...customFrenchMessages},
    en_US: {...englishMessages, ...customEnglishMessages}
};



// WEBPACK FOOTER //
// ./src/i18n/index.js